<template>
	<section :id="id" class="bmed-component navbar w-full h-navbar border-t border-b border-gray-002">
		<div class="wrapper h-full">
			<div class="container h-full max-h-full px-5 py-1 md:py-5">
				<div class="h-full flex flex-row justify-between items-center">
					<nav class="md:w-8/12">
						<CategoryDropdown
							v-if="categories && categories.length > 0"
							class="hidden md:block"
							label="Categories"
							:list="categories"
							:rows="7"
						/>
						<span class="md:hidden">
							<UiButton
								type="icon"
								name="menu"
								theme="transparent"
								:on-click="showNavMenu"
							/>
						</span>
					</nav>
					<div class="logo absolute left-1/2 top-1/2 transform -translate-y-1/2 -translate-x-1/2">
						<UiLogo mode="secondary"/>
					</div>
					<div class="md:w-4/12">
						<div class="hidden md:flex flex-row justify-end items-center">
							<SearchBar 
								class="flex-1 mr-6" 
								:border-color="searchBorderColor"
							/>
							<div>
								<UiButton 
									v-if="!isAuth"
									label="Log In"
									:on-click="userLogin"
								/>
								<UiButton 
									v-else
									label="Log Out"
									theme="secondary"
									:on-click="userLogout"
								/>
							</div>
						</div>
						<span class="md:hidden">
							<UiButton
								type="icon"
								name="magnify"
								theme="transparent"
								:on-click="showNavMenuSearch"
							/>
						</span>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
import globalMixins from '@/mixins/global-mixins'

import UiLogo from '@/components/ui/Logo'
import UiButton from '@/components/ui/Button'
import SearchBar from '@/components/search/Bar'
import CategoryDropdown from '@/components/category/Dropdown'

export default {
	name: 'NavBar',
	props: {
		id: {
			type: String,
			default: 'navBar'
		},
		siblings: {
			type: String,
			default: ''
		}
	},
	components: {
		UiLogo,
		UiButton,
		SearchBar,
		CategoryDropdown
	},
	mixins: [
		globalMixins
	],
	data() {
		return {
			offsetTop: 0,
			searchBorderColor: 'black'
		}
	},
  mounted() {
		this.setOffsetTop()
		this.stickyNav()
		window.addEventListener('scroll', this.stickyNav)
		window.addEventListener('resize', this.setOffsetTop)
  },
  beforeUnmount() {
		window.removeEventListener('scroll', this.stickyNav)
		window.removeEventListener('resize', this.setOffsetTop)
  },
  methods: {
		setOffsetTop() {
			this.offsetTop = this.getOffsetTop(this.siblings.split(','))
		},
    stickyNav() {
			const navbar = this.$el
			if (window.pageYOffset >= this.offsetTop) {
				this.searchBorderColor = 'white'
				navbar.classList.add('sticky-navbar')
				// this.setContentMargin()
			} else {
				this.searchBorderColor = 'black'
				navbar.classList.remove('sticky-navbar');
				// this.setContentMargin()
			}
    }
  }
}
</script>

<style src="@/assets/css/tailwind.css"></style>
<style src="@/assets/css/_config.css"></style>
<style src="@/assets/css/_global.css"></style>
<style src="@/assets/css/animations.css"></style>
<style src="@/assets/css/main.css"></style>

<style scoped>
.navbar {
	z-index: 99;
	transition: height 0.2s linear,
	background-color 0.2s linear;
}

.sticky-navbar {
	position: fixed;
	top: 0;
	min-height: var(--navbar-height-sticky-mobile) !important;
	background-color: var(--secondary-bgcolor);
	color: var(--secondary-textcolor);
	border: none !important;
}

.logo { display: none; width: var(--logo-width-sm); }
.sticky-navbar .logo { display: block; }
</style>